import { defineComponent as _defineComponent } from 'vue'
import kebabCase from "lodash/kebabCase";
import QueryParams, {Configuration} from "@/app/helpers/QueryParams";
import {computed} from "vue";
import CallToActionButton from "@/components/CallToActionButton.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ConversionButtonsCard',
  props: {
    config: null
  },
  setup(__props: any) {

const props = __props as {
  config: Configuration;
};




const queryParams = computed(() => QueryParams.build(props.config))

return { __sfc: true,props, queryParams, kebabCase, CallToActionButton }
}

})